import { useEffect } from "react";
import { useSelector } from "react-redux";
import { S3_BASE_URL } from "./Service";


const DynamicHead = ({ host }) => {
  const domains = useSelector((state) => state.data.domains);

  useEffect(() => {
    if (!domains || domains.length === 0 || !host) return;

    const matched = domains.find(site =>
      site.domainList.includes(host)
    );

    if (matched?.logo2) {
        const faviconUrl = `${S3_BASE_URL}/${matched.logo2}`;

      let favicon = document.getElementById("dynamic-favicon");
      if (!favicon) {
        favicon = document.createElement("link");
        favicon.rel = "icon";
        favicon.id = "dynamic-favicon";
        document.head.appendChild(favicon);
      }

      favicon.href = faviconUrl;
    }

    if (matched?.name) {
      document.title = matched.name;
    }
  }, [domains, host]);

  return null; 
};

export default DynamicHead;